import { render, staticRenderFns } from "./ScrollingDocument.vue?vue&type=template&id=20b686fa&scoped=true&"
import script from "./ScrollingDocument.vue?vue&type=script&lang=js&"
export * from "./ScrollingDocument.vue?vue&type=script&lang=js&"
import style0 from "../../assets/scss/scrolling_document.scss?vue&type=style&index=0&id=20b686fa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b686fa",
  null
  
)

export default component.exports